import { useCallback } from 'react';
import { match } from 'ts-pattern';
import {
  TalentDropdown as OldTalentDropdown,
  Select,
  SelectOption,
  TALENT_DROPDOWN_VALUES,
} from 'ui-components';
import { FEATURE_FLAGS } from '~/constants';
import {
  CONTENT_SEARCH_PARAMS,
  CONTENT_SEARCH_ROSTER,
} from '~/hooks/useContentSearch';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { usePersistedState } from '~/hooks/usePersistedState';

import { IContentSearchQuery } from '../ContentSearchFilter.types';

interface ITalentDropdownProps {
  onChange: (filters: Partial<IContentSearchQuery>) => void;
  trackId?: string;
}

export const TalentDropdown: React.FC<ITalentDropdownProps> = ({
  onChange,
  trackId,
}) => {
  const [talentOption, setTalentOption] = usePersistedState(
    'talentOption',
    TALENT_DROPDOWN_VALUES.agency,
  );

  const savedListRosterFlag = useFeatureFlag(
    FEATURE_FLAGS.foamSavedListsRoster,
  );

  const handleChange = useCallback(
    (value: string) => {
      onChange({
        [CONTENT_SEARCH_PARAMS.roster]:
          value === TALENT_DROPDOWN_VALUES.agency
            ? CONTENT_SEARCH_ROSTER.agency
            : CONTENT_SEARCH_ROSTER.myTalent,
        [CONTENT_SEARCH_PARAMS.creator]: '',
      });
      setTalentOption(value as TALENT_DROPDOWN_VALUES);
    },
    [onChange, setTalentOption],
  );

  return match(savedListRosterFlag)
    .with('enabled', () => (
      <Select
        value={talentOption}
        onChange={({ value }) => handleChange(value)}
        placeholder="Talent Option"
        trackId="filterbar-toggle-agency"
        variant="borderless"
      >
        <SelectOption
          value={TALENT_DROPDOWN_VALUES.agency}
          trackId="talent-option-agency"
        >
          All Talent
        </SelectOption>
        <SelectOption
          value={TALENT_DROPDOWN_VALUES.self}
          trackId="talent-option-roster"
        >
          My Talent
        </SelectOption>
      </Select>
    ))
    .otherwise(() => (
      <OldTalentDropdown
        onChange={handleChange}
        defaultValue={talentOption}
        trackId={`${trackId}-${
          talentOption === TALENT_DROPDOWN_VALUES.self
            ? CONTENT_SEARCH_ROSTER.myTalent
            : CONTENT_SEARCH_ROSTER.agency
        }`}
      />
    ));
};
